import { put, call, take, fork } from 'redux-saga/effects'
import { setCertificatePriceService } from 'src/api/certificate'
import {
  patchCertificatePriceSuccess,
  patchCertificatePriceError,
} from 'src/reducers/certificate/action'
import { PATCH_CERTIFICATE_PRICE } from 'src/reducers/certificate/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

function* flow(payload) {
  try {
    const { collectionId, data, callback } = payload
    const response = yield call(setCertificatePriceService, collectionId, data)
    yield put(patchCertificatePriceSuccess(data))
    yield put(operationSuccess())
    if (callback) callback(response?.data ?? response)
  } catch (error) {
    yield put(patchCertificatePriceError(error))
    yield put(operationFail(error))
  }
}

export default function* patchCertificatePriceWatcher() {
  while (true) {
    const action = yield take(PATCH_CERTIFICATE_PRICE)
    yield fork(generalSaga, flow, action.payload)
  }
}
